export const CUSTOMER_TEMPLATE_LEGACY_TYPE = "CONTACTORDERSTATUS";

export const CUSTOMER_TEMPLATE_TYPE_LABELS: Record<string, string> = {
  CONTACTORDERSTATUS_C: "Notificação status de pedido (Confirmado)",
  CONTACTORDERSTATUS_P: "Notificação status de pedido (Pago)",
  CONTACTORDERSTATUS_H: "Notificação status de pedido (Em manuseio)",
  CONTACTORDERSTATUS_I: "Notificação status de pedido (Faturado)",
  CONTACTORDERSTATUS_S: "Notificação status de pedido (Enviado)",
  CONTACTORDERSTATUS_D: "Notificação status de pedido (Entregue)",
  CONTACTORDERSTATUS_L: "Notificação status de pedido (Cancelado)",
  STARTCONVERSATION: "Iniciar conversa",
  RESTARTCONVERSATION: "Reiniciar conversa",
};

export const getCustomerTemplateTypeLabel = (type: string): string =>
  CUSTOMER_TEMPLATE_TYPE_LABELS[type] ?? type;

export const isLegacyCustomerTemplateType = (type: string): boolean =>
  type === CUSTOMER_TEMPLATE_LEGACY_TYPE;

export const CUSTOMER_TEMPLATE_STATUS_LABELS: Record<string, string> = {
  A: "A - Ativo",
  H: "H - Em homologação",
  R: "R - Rejeitado",
};

export const getCustomerTemplateStatusLabel = (status: string): string =>
  CUSTOMER_TEMPLATE_STATUS_LABELS[status] ?? status;

export const CUSTOMER_TEMPLATE_STATUS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "A", label: "A - Ativo" },
  { value: "H", label: "H - Em homologação" },
  { value: "R", label: "R - Rejeitado" },
];

export type TemplateVariableGroup = {
  title: string;
  variables: string[];
};


export const TEMPLATE_PREVIEW_SAMPLES: Record<string, string> = {};

// A pré-visualização mostra o texto exatamente como foi escrito,
// mantendo as tags (#CONTACTNAME#, #ORDERNUMBER#, ...) sem valores fictícios.
export const buildTemplatePreview = (text: string): string => text || "";


// Remove o sufixo de data do nome (ex.: ..._2026_1_7) apenas na exibição.
export const formatCustomerTemplateName = (name?: string | null): string =>
  (name ?? "").replace(/_\d{4}_\d{1,2}_\d{1,2}$/, "");
